var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"button",class:[("button--" + _vm.color), ("button--" + _vm.variant)],on:{"click":_vm.on_click}},[_vm._t("default",[_vm._v("Start Free Trial")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }